// Some super evil that was added ages ago, but I'm too tired to
// get rid of and figure out how to do things properly
export const nextAnimationFrame = (): Promise<void> => {
	return new Promise((resolve) => {
		requestAnimationFrame(() => {
			requestAnimationFrame(() => {
				setTimeout(() => {
					resolve();
				}, 0);
			});
		});
	});
};
